import ReportMappingLayoutComponent from '../Components/Report/MappingLayout.tsx';
import { fetchAPI } from '../../api/GenericFetch.js';
import { Suspense } from 'react';
import { useLoaderData, Await } from 'react-router-dom';
import { GET_BU_LIST_URL, GET_RACK_TYPE_LIST_URL } from '../../const/APIUrl.js';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MappingLayout(){
    const pageFunction = getPageFunction({pageId : pageEnum.MappingLayoutReport});
    const listData = useLoaderData();    
    return (        
        <Suspense>
        { <Await resolve={listData}>
          {(listData) => <ReportMappingLayoutComponent locationList={listData.locationList}
            rackTypeList={listData.rackTypeList} pageFunction={pageFunction}/>}
        </Await> }
      </Suspense>
    );
}

export async function loader() {
  const [locationList,  rackTypeList] = await Promise.all([
        fetchAPI({url:GET_BU_LIST_URL}),
        fetchAPI({url:GET_RACK_TYPE_LIST_URL})        
    ]);
    return {locationList, rackTypeList};
}
